import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReceiptThumbnail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 47,
	height: 85,
	viewBox: "0 0 47 85",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_6311_40949)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M38.4906 3H8.50938C7.67577 3 7 4.12474 7 5.51219V71.4878C7 72.8753 7.67577 74 8.50938 74H38.4906C39.3242 74 40 72.8753 40 71.4878V5.51219C40 4.12474 39.3242 3 38.4906 3Z",
				fill: "white"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M38.4905 3.15674H8.50928C7.72777 3.15674 7.09424 4.21119 7.09424 5.51191V71.4875C7.09424 72.7883 7.72777 73.8427 8.50928 73.8427H38.4905C39.272 73.8427 39.9056 72.7883 39.9056 71.4875V5.51191C39.9056 4.21119 39.272 3.15674 38.4905 3.15674Z",
				stroke: "#D0D5DD",
				strokeWidth: .5
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.2414 8.90967H12.7378C12.5466 8.90967 12.3916 9.1783 12.3916 9.50967V14.3097C12.3916 14.641 12.5466 14.9097 12.7378 14.9097H35.2414C35.4326 14.9097 35.5876 14.641 35.5876 14.3097V9.50967C35.5876 9.1783 35.4326 8.90967 35.2414 8.90967Z",
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.4376 58H25.686C25.6032 58 25.536 58.1791 25.536 58.4V61.6C25.536 61.8209 25.6032 62 25.686 62H35.4376C35.5205 62 35.5876 61.8209 35.5876 61.6V58.4C35.5876 58.1791 35.5205 58 35.4376 58Z",
			fill: "#E4E8EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3916 23.9097H26.3092",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3916 17.9097H34.8144",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3916 28.9097H26.3092",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.1752 23.9097L34.8144 23.9097",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.1752 28.9097L34.8144 28.9097",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3916 34.9097H26.3092",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.1752 34.9097L34.8144 34.9097",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3916 39.9097H26.3092",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.1752 39.9097L34.8144 39.9097",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3916 45.9097H26.3092",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 52H34.9176",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.1752 45.9097L34.8144 45.9097",
			stroke: "#A9B4B9",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_6311_40949",
			x: .844238,
			y: .906738,
			width: 45.3113,
			height: 83.186,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_6311_40949"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_6311_40949",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgReceiptThumbnail;
